module.exports = __webpack_public_path__ + "assets/img/amex.ac8896b0.png";